import { axiosInstance } from './ApiConfig';
import GetBrowser from './GetBrowser';

export async function FetchAllConfigurations(level, setCrmInfo) {
  const browserName = GetBrowser();
  const response = await axiosInstance({
    method: 'GET',
    url: '/configurations',
    headers: {
      'X-Browser-Name': browserName,
      user_level: level,
    },
  });

  if (response.status === 200) {
    const roles = response.data?.roles;
    if (roles.includes('admin'))
      setCrmInfo({
        is_admin: true,
      });
    return response.data.value;
  } else {
    throw new Error('Failed to fetch configurations');
  }
}
